import { Constants } from "@/constant/Constants";
import { Config } from "@/data/Config";
import { SelectData } from "@/data/SelectData";
import { GameConfigType, GameDataType } from "@/types";

export class Game extends SelectData {
  protected imageUrl: string;
  protected configs: Config[];
  protected versions: string[];
  private _configPath?: string;
  private _serverPath: string;
  private _clientPath: string;
  private _defaultCurrency: string;
  private _serverPort: number;
  private _forceLocal: number;
  private _defaultParams: string;
  protected _selectedConfig: Config;
  private _version?: string;
  private _buildPrefix: string;
  private _tag?: string;
  private _gameIdPrefix?: string;

  constructor(data: GameDataType) {
    super();
    this._id = data[Constants.ID];
    this._tag = data[Constants.TAG];
    this._name = data[Constants.NAME];
    this._serverPath = data[Constants.SERVER_PATH];
    this._clientPath = data[Constants.CLIENT_PATH];
    this._forceLocal = data[Constants.FORCE_LOCAL];
    this._buildPrefix = data[Constants.BUILD_PREFIX];
    this._defaultParams = data[Constants.DEFAULT_PARAMS];
    this._defaultCurrency = data[Constants.DEFAULT_CURRENCY];
    this._serverPort = data[Constants.SERVER_PORT];
    this.solidifyImageUrl(data[Constants.IMAGE_NAME]);
    this.setGameConfig(data[Constants.CONFIGS]);
    this._configPath = data[Constants.CONFIG_PATH];
    this._gameIdPrefix = data[Constants.GAME_ID_PREFIX];
  }

  private solidifyImageUrl(imageName: string): void {
    this.imageUrl = `${Constants.AWS_URL}/frontend-lobby/data/banners/${imageName}`;
  }

  setGameConfig(data: Array<GameConfigType>): void {
    this.configs = [];
    if (data) {
      for (const configData of data) {
        this.configs.push(new Config(configData));
      }
      if (this.configs.length > 0) {
        this._selectedConfig = this.configs[0];
      }
    }
  }

  setGameVersions(data: Array<string>): void {
    this.versions = [];
    if (data) {
      for (const versionData of data) {
        this.versions.push(versionData);
      }
      if (this.versions.length > 0) {
        this._version = this.versions[0];
      }
    }
  }

  get tag(): string | undefined {
    return this._tag;
  }

  get name(): string {
    return this._name;
  }

  public getImageUrl(): string {
    return this.imageUrl;
  }

  public getConfigs(): Config[] {
    return this.configs;
  }

  public getVersions(): string[] {
    return this.versions;
  }

  get selectedConfig(): Config {
    return this._selectedConfig;
  }

  set selectedConfig(value: Config) {
    this._selectedConfig = value;
  }

  get forceLocal(): number {
    return this._forceLocal;
  }

  set forceLocal(value: number) {
    this._forceLocal = value;
  }

  get defaultParams(): string {
    return this._defaultParams;
  }

  set defaultParams(value: string) {
    this._defaultParams = value;
  }

  get clientPath(): string {
    return this._clientPath;
  }

  set clientPath(value: string) {
    this._clientPath = value;
  }

  get serverPath(): string {
    return this._serverPath;
  }

  set serverPath(value: string) {
    this._serverPath = value;
  }

  get serverPort(): number {
    return this._serverPort;
  }

  set serverPort(value: number) {
    this._serverPort = value;
  }

  set defaultCurrency(value: string) {
    this._defaultCurrency = value;
  }

  get defaultCurrency(): string {
    return this._defaultCurrency;
  }

  get configPath(): string | undefined {
    return this._configPath;
  }

  get version(): string | undefined {
    return this._version;
  }

  set version(v: string) {
    this._version = v;
  }

  get buildPrefix(): string {
    return this._buildPrefix;
  }

  set buildPrefix(prefix: string) {
    this._buildPrefix = prefix;
  }

  get gameIdPrefix(): string | undefined {
    return this._gameIdPrefix;
  }
  
}
